import React from 'react';
import { trackClick } from '../../firebase/analytics';
import { Helmet } from "react-helmet";
import Reveal from '../../components/ui/Reveal';
import Button from '../../components/ui/Button';

// Screen-scoped layout. Design tokens and primitives come from
// src/design-system, which is imported once in src/index.js.
import './scss/cv-styles.scss'; // scss = sassy css (advanced css with variables, nesting, etc.)

// Import local assets
import profileImage from '../../assets/images/profile.png';
import resume from '../../assets/download/Keval Langalia - Resume - v9.pdf';


const CV = () => (
  <main id="main" className="cv-page" tabIndex={-1}>
  <div className="cv-layout">
    <Helmet>
        <title>Keval's Resume and CV</title>
        <meta name="description" content="View Keval's CV and professional experience." />
        <link rel="canonical" href="https://keval.io/cv" />
    </Helmet>
    <Reveal as="div" className="cv-sidebar" delay={0}>
      <div className="cv-profile">
        <img className="cv-profile-image" src={profileImage} alt="Keval Langalia" />
        <h1 className="cv-person-name">Keval Langalia</h1>
        <h3 className="cv-role-tagline">Sr. Software Engineer</h3>
      </div>

      <div className="cv-contact-block cv-block">
        <ul className="kds-list cv-contact-list">
          <li className="cv-contact-email">
            <i className="fas fa-location-dot"></i>
            <a className="cv-contact-link" href="https://goo.gl/maps/zfUdoVxxKt7dcZMaA" onClick={trackClick('cv', 'current_city_link')}>Toronto, Canada</a>
          </li>
          <li className="cv-contact-email">
            <i className="fas fa-envelope"></i>
            <a className="cv-contact-link" href="mailto:hello@keval.io" onClick={trackClick('cv', 'email_link')}>hello@keval.io</a>
          </li>
          <li className="cv-contact-website">
            <i className="fas fa-globe"></i>
            <a className="cv-contact-link" href="https://keval.io" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'website_link')}>keval.io</a>
          </li>
          <li className="cv-contact-website">
            <i className="fab fa-android"></i>
            <a className="cv-contact-link" href="https://modernandroid.dev" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'modern_android_link')}>modernAndroid.dev</a>
          </li>
          <li className="cv-contact-linkedin">
            <i className="fab fa-linkedin-in"></i>
            <a className="cv-contact-link" href="https://www.linkedin.com/in/kevallangalia/" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'linkedin_link')}>linkedin.com/in/kevallangalia</a>
          </li>
          <li className="cv-contact-github">
            <i className="fab fa-github"></i>
            <a className="cv-contact-link" href="https://github.com/thekeval" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'github_link')}>github.com/thekeval</a>
          </li>
          <li className="cv-contact-twitter">
            <i className="fa-brands fa-x-twitter"></i>
            <a className="cv-contact-link" href="https://x.com/kevallangalia" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'x_twitter_link')}>@kevallangalia</a>
          </li>
          <li className="cv-contact-stackoverflow">
            <i className="fab fa-stack-overflow"></i>
            <a className="cv-contact-link" href="https://stackoverflow.com/users/2049623/keval-langalia" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'stackoverflow_link')}>StackOverflow Profile</a>
          </li>
          <li className="cv-download-item">
            <Button href={resume} className="cv-download-link" download onClick={trackClick('cv', 'download_resume_link')}>
              Download Resume
            </Button>
          </li>
        </ul>
      </div>

      <div className="cv-education-block cv-block">
        <h2 className="cv-block-title">Education</h2>
        <div className="cv-entry">
          <h4 className="cv-degree-title">Post Graduation in Mobile Application Development</h4>
          <h5 className="cv-entry-meta">Lambton College in Toronto</h5>
          <div className="cv-entry-time">2021 - 2022</div>
        </div>
        <div className="cv-entry">
          <h4 className="cv-degree-title">Bachelor of Computer Engineering</h4>
          <h5 className="cv-entry-meta">Gujarat Technological University</h5>
          <div className="cv-entry-time">2009 - 2013</div>
        </div>
      </div>

      <div className="cv-education-block cv-block">
        <h2 className="cv-block-title">Developer Communities</h2>
        <div className="cv-entry">
          <h4 className="cv-degree-title">
            <a href="https://developers.google.com/community/gdg" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'gdg_link')}>Google Developer Groups</a>
          </h4>
          <div className="cv-entry-time">GDG Ahmedabad</div>
          <div className="cv-entry-time">GDG Gandhinagar</div>
          <div className="cv-entry-time">November 2015 - present</div>
        </div>
        <div className="cv-entry">
          <h4 className="cv-degree-title">
            <a href="https://studentpartners.microsoft.com/" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'ms_student_partner_link')}>Microsoft Student Partner</a>
          </h4>
          <div className="cv-entry-time">December 2012 - April 2014</div>
        </div>
      </div>

      <div className="cv-languages-block cv-block">
        <h2 className="cv-block-title">Languages</h2>
        <ul className="kds-list cv-interest-list">
          <li>English <span className="cv-language-level">(Professional)</span></li>
          <li>Hindi <span className="cv-language-level">(Professional)</span></li>
          <li>Gujarati <span className="cv-language-level">(Native)</span></li>
        </ul>
      </div>

      <div className="cv-interests-block cv-block">
        <h2 className="cv-block-title">Interests</h2>
        <ul className="kds-list cv-interest-list">
          <li>Artificial Intelligence</li>
          <li>Astronomy & Cosmology</li>
          <li>Spirituality</li>
          <li>Sci-Fi Movies & Books</li>
          <li>Video Games</li>
          <li>Travelling & Exploring</li>
        </ul>
      </div>
    </Reveal>

    <div className="cv-main">
      <Reveal as="section" className="cv-section cv-summary-section" delay={60}>
        <h2 className="cv-heading">
          <span className="cv-heading-icon">
            <i className="fas fa-user cv-heading-icon-glyph"></i>
          </span>
          <span className="cv-heading-text">Career Profile</span>
        </h2>
        <div className="cv-summary-copy">
          <p>
            Over 12 years of experience developing and architecting mobile solutions in various industries focused on Android platforms
including AOSP, leading teams through full SDLC as an SME, and driving adoption of modern design patterns, CI/CD automation, and
secure coding practices. Proven record of reducing defects, improving reliability, and mentoring engineers to raise technical bar.
          </p>
          {/* <p>Over 10 years of work experience in different industries, focused on Android application development for Mobile, Automotive, TV, Wearable, and Cross-Platform using Kotlin and Java.</p>
          <p>Fluent in using Android Jetpack Libraries, including life-cycle components, Material Design components, Navigation, Dependency Injection (Dagger Hilt), SQLite Room, data binding, and Coroutines.</p>
          <p>Good experience in product conceptualization, POC, prototyping, wireframing software, database design, design patterns, and designing system architecture.</p>
          <p>I believe the art is in the ability to learn!</p> */}
        </div>
      </Reveal>

      <Reveal as="section" className="cv-skills-section cv-section" delay={120}>
        <h2 className="cv-heading">
          <span className="cv-heading-icon">
            <i className="fas fa-rocket cv-heading-icon-glyph"></i>
          </span>
          <span className="cv-heading-text">Technical Competencies</span>
        </h2>
        <div className="cv-skills-list">
          <ul>
            <li>
              <div><span className="cv-skill-label">Platforms:</span> Android (Mobile, Automotive OS, TV, Wearable), Cross Platform using React Native and QT, QNX RTOS </div>
            </li>
          </ul>
          <ul>
            <li>
              <div><span className="cv-skill-label">Languages and Libraries:</span> Kotlin, Java, C++, Reactive (RxJava/RxCpp), python, Jetpack Compose, Dagger/Hilt, Coroutines</div>
            </li>
          </ul>
          <ul>
            <li>
              <div><span className="cv-skill-label">Architecture & Patterns:</span> Clean Architecture, MVVM, MVI, MVP, API Gateway, Dependency Injection and Design Patterns</div>
            </li>
          </ul>
          <ul>
            <li>
              <div><span className="cv-skill-label">DevOps and Cloud:</span> CI/CD with Jenkins, GitHub Workflows/Actions, Gradle, shell scripts, AWS, Azure, Firebase, GitOps</div>
            </li>
          </ul>
          <ul>
            <li>
              <div><span className="cv-skill-label">Testing & Quality:</span> JUnit, Espresso, Mockito, Robolectric, performance profiling</div>
            </li>
          </ul>
          <ul>
            <li>
              <div><span className="cv-skill-label">Version Controls and Project Management:</span> Git, Bitbucket, SVN, Jira Cloud/Align, Confluence, Asana</div>
            </li>
          </ul>
          <ul>
            <li>
              <div><span className="cv-skill-label">SDLC Practices:</span> Agile software development with daily Scrum, Sprint planning, and Cadence based planning</div>
            </li>
          </ul>
          <ul>
            <li>
              <div><span className="cv-skill-label">Leadership:</span> Coaching and mentoring for best practices, defect postmortems, and cross-team collaboration</div>
            </li>
          </ul>
          
        </div>
      </Reveal>

      <Reveal as="section" className="cv-section cv-experience-section" delay={180}>
        <h2 className="cv-heading">
          <span className="cv-heading-icon">
            <i className="fas fa-briefcase cv-heading-icon-glyph"></i>
          </span>
          <span className="cv-heading-text">Experiences</span>
        </h2>
        <div className="cv-entry">
          <div className="cv-entry-meta">
            <div className="cv-entry-header">
              <h3 className="cv-entry-title">Senior Software Engineer (Contract)</h3>
              <div className="cv-entry-time">April 2026 - Present</div>
            </div>
            <div className="cv-entry-company">
              <a href="https://www.ford.com/" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'ford_motors_link')}>Ford Motors</a> (via <a href="https://www.teksystems.ca" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'teksystems_link')}>TEKSystems Canada</a>) - Toronto, CA
            </div>
          </div>
          <div className="cv-entry-details">
            <ul>
              <li>Owned development of TTPMS and Driveline Status experiences for Android Automotive OS using Kotlin, Jetpack Compose, ViewModel, StateFlow and VHAL, supporting multiple trailer layouts, pressure/temperature monitoring, warnings, steering tire states and synchronized animations across Center Stack and Panoramic Display widgets.</li>
              <li>Architected cross-application Towing and TTPMS settings integration across Car Settings, Driver Assist Widgets and Trailer Features, including two build variant separation, feature gating, explicit Intent contracts and Quick Access UI.</li>
              <li>Led root-cause analysis of complex signal and UI timing defects, eliminating stale-data race conditions between TTPMS screens and Panoramic screen widgets. Developed scalable, data-driven Junit/Robolectric tests and validated integrations using Gradle, Soong, ADB and Ford internal tools.</li>
            </ul>
          </div>
        </div>
        <div className="cv-entry">
          <div className="cv-entry-meta">
            <div className="cv-entry-header">
              <h3 className="cv-entry-title">Senior Software Engineer</h3>
              <div className="cv-entry-time">October 2022 - December 2025</div>
            </div>
            <div className="cv-entry-company">
              <a href="https://www.gm.com/" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'general_motors_link')}>General Motors</a> (via <a href="https://www.teksystems.ca" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'teksystems_link')}>TEKSystems Canada</a>) - Toronto, CA
            </div>
          </div>
          <div className="cv-entry-details">
            <ul>
              <li>Contributed to multiple products under Vehicle Infotainment domain such as Vehicle Status/Performance app, Apple CarPlay Service, and utility apps such as Virtual Controls, HVAC app and EV/HEV Charging app.</li>
              <li>Designed and developed end-to-end migration strategy from Rx to Coroutine and led the CPU and resource optimization efforts with intricate threading mechanism, used by entire infotainment domain through Core android library.</li>
              <li>Owned Dyno graph and G-force gauge features in Vehicle Performance App, which is delivered in Chevrolet Corvette series vehicles to showcase and represent several engine/vehicle performance metrics in real-time as well as historical data points.</li>
              <li>Set-up GitHub workflows for daily builds, automated unit/espresso tests trigger, and copilot review. Used SonarQube to monitor in-depth unit coverage, CodeQL to identify vulnerabilities, FOSSA for generating SBOMs and licensing verification.</li>
              <li>Developed pipeline to trigger unit/espresso test coverage comparison for each individual Pull Request with mainline, script host the comparison graph on GitHub Pages. This resulted in {'>'}95% unit tests coverage all times.</li>
              <li>Utilized the Artificial Intelligence, AI capabilities, to improve the delivery timelines by using GitHub Copilot with various models such as Claude Opus, Sonnet and GPT Codex. Created and connected MCP servers for custom data access for AI.</li>
              <li>Developed CPU monitoring tool in python to meticulously observe resources consumed by each thread within selected process, calculate average usage for comparison and plot them in a chart to be submitted with test reports.</li>

              <li>CarPlay Service: Worked on both wired and wireless CarPlay, KPI for connectivity, implemented iAP2 protocol for FastConnect, Cinemo SDK Integration, Media playback, Audio ducking for multiple media sources and Lane Guidance for map{'’'}s navigation. Additionally, developed Card View UI for CarPlay to be displayed on Home Page, for the HMI layer.</li>
              <li>Took shared ownership of Voice Assistance (VA) domain, managing multiple VA such as Siri and native VA. Contributed as domain expert for Connectivity flow of wired and wireless CarPlay.</li>
              <li>Led the defect triage and resolution efforts, including ANRs and black screen issues, analyzing gigabyte-scaled logs using ATS utility, Beagle box, various scripts and text analysis tools.</li>
              <li>RTOS Apps with QT: Contributed to development of 2 RTOS apps, Virtual Controls (VC) and Climate Controls (HVAC), targeted to QNX using QT platform SDK. Took feature ownership of Dome Light controls in VC and Defrost in HVAC.</li>
              <li>Charging App: Worked with various system properties for charging features such as active charging, schedule charging, delay charging, and DWL (driving with payload for trailering) charging. Contributed to development of card view UI for charging app, writing Gradle scripts to automate the view navigation and recording video through shell scripts.</li>
              <li>Additionally, worked on localization for RTL languages and adding mock scripts for testing and verification.</li>


              {/* <li>Contributed to multiple projects under Vehicle Infotainment, Virtual Controls, and Climate Control Systems such as Apple CarPlay service, HVAC App, Vehicle Status App, Performance App, and Energy (Charging for EV) App.</li>
              <li>CarPlay Service: Worked on both wired and wireless CarPlay, KPI for connectivity, implemented iAP2 protocol for FastConnect, Cinemo SDK Integration, Media playback, Audio ducking for multiple media sources, and Lane Guidance for map navigation.</li>
              <li>Took shared ownership of Voice Assistance (VA) domain, managing multiple VA such as Siri and native VA. Contributed as domain expert for Connectivity flow of wired and wireless CarPlay. Languages used include Java, Kotlin, and C++ for services, and Python for scripting.</li>
              <li>Worked with ATS utility and Beagle box to collect logs. Resolved approximately 117 defects by analyzing large logs using various scripts and text analysis tools, including ANRs and black screen issues.</li>
              <li>RTOS Apps with QT: Contributed to the development of two RTOS apps, Virtual Controls (VC) and Climate Controls (HVAC), targeted to QNX using QT platform SDK. Took feature ownership of Dome Light controls in VC and Defrost in HVAC.</li>
              <li>Integrated CAN signal handling for owned features while using in-house built tool to mock the CAN signals for testing. This project was partially developed in RxCPP and Qt libraries, using CMake for build tools.</li>
              <li>Contributed to developing a tool to automate the flashing process for different builds to VCU and push various calibrations according to the selected display. Also contributed to CAN signal integration in a vehicle simulator.</li>
              <li>Charging App: Worked on various system properties for charging features such as active charging, schedule charging, delay charging, and DWL (Driving With Load) charging. Contributed to developing card view UI for the charging app, writing Gradle scripts to automate view navigation, and recording video through shell scripts.</li>
              <li>Worked on localization for RTL languages and adding mock scripts for testing and verification. This project used Kotlin, Groovy for mock scripts, Dagger for DI, and shell scripts for testing automation.</li> */}
            </ul>
          </div>
        </div>

        <div className="cv-entry">
          <div className="cv-entry-meta">
            <div className="cv-entry-header">
              <h3 className="cv-entry-title">Software Engineer (Contract)</h3>
              <div className="cv-entry-time">April 2022 - October 2022</div>
            </div>
            <div className="cv-entry-company">
              <a href="https://www.cerence.com/" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'cerence_link')}>Cerence</a> (via <a href="https://www.lynxtechgroup.com" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'lynxtech_link')}>LynxTech Group LLC</a>) - Toronto, CA
            </div>
          </div>
          <div className="cv-entry-details">
            <ul>
              <li>Worked on Voice Assistance Android Automotive SDK to be integrated by OEM.</li>
              <li>Implemented voice recognition engine powered by an in-house AI library and handled communication between VUI and GUI for command and intent generation.</li>
              <li>Owned complete responsibility of the Media Domain, which includes Media playback, user favorites, personalization, preferences, and music provider Spotify.</li>
              <li>Worked on Unit testing for all domains such as Media, Radio, Reminder, Memo, Messaging, etc. using JUnit and Mockito with the help of Dagger2 (DI).</li>
            </ul>
          </div>
        </div>
        <div   className="cv-entry">
                    <div   className="cv-entry-meta">
                        <div   className="cv-entry-header">
                            <h3   className="cv-entry-title">Android Engineer (Contract)</h3>
                            <div   className="cv-entry-time">November 2021 - December 2021</div>
                        </div>
                        <div   className="cv-entry-company"><a href="https://rbglobal.com/" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'ritchi_bros_link')}>Ritchi Brothers</a> (via <a href="https://www.accionlabs.com" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'accionlabs_link')}>Accion Labs</a>) - Toronto, CA</div>
                    </div>
                    <div   className="cv-entry-details">
                        <ul>
                            <li>Built dynamic Product Details Page for assets to put out for auctions, the page includes server-controlled data and modules. Used content-stack to organize localized string resources.</li>
                            <li>Implemented AWS Amplify library for fetching data through GraphQL queries and update with mutations. Used subscription to enable real-time data integration in Mobile app.</li>
                        </ul>
                    </div>
                </div>

                <div   className="cv-entry">
                    <div   className="cv-entry-meta">
                        <div   className="cv-entry-header">
                            <h3   className="cv-entry-title">Consultant Mobile Engineer</h3>
                            <div   className="cv-entry-time">March 2017 - May 2020</div>
                        </div>
                        <div   className="cv-entry-company"><a href="https://www.jiosaavn.com/corporate" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'jiosaavn_link')}>JioSaavn (Saavn Media Pvt Ltd)</a> - Mumbai, India</div>
                    </div> 
                    <div   className="cv-entry-details">
                        <ul>
                            <li>Built Lyrics feature for android mobile and TV app in sync with music including annotations and timestamp in Kotlin language using Kotlin Coroutines, RecyclerView, custom views. Wrote Unit tests for this feature using JUnit and Espresso.</li>
                            <li>Worked on user-profile personalization which includes developing modular home screen based on API call response. developed in Kotlin using Retrofit, Gson, Room database and repository design pattern.</li>
                            <li>Developed Android TV application for JioSaavn using Leanback library. Managed different versions for various manufacturers such as Jio Set-top-box, Amazon Firestick and OnePlus TV. This was developed in Java and used navigation library, databinding, compose animations etc.</li>
                            <li>Migrated existing code to build Android Automotive app (car system) and SDK to be integrated in third party apps ensuring flowless execution and smooth user experience. Accountable for managing notifications catalog and sending push notifications to targeted users through Firebase Cloud Messaging service.</li>
                            <li>Worked on optimizing app performance by monitoring stats from Android Profiler in Android Studio. Used Firebase Crashlitics to identify and eliminate crashes and bugs. Published multiple versions of the app on Play store.</li>
                        </ul>
                    </div>  
                </div>  
                
                <div   className="cv-entry">
                    <div   className="cv-entry-meta">
                        <div   className="cv-entry-header">
                            <h3   className="cv-entry-title">Software Engineer</h3>
                            <div   className="cv-entry-time">March 2016 - March 2017</div>
                        </div>  
                        <div   className="cv-entry-company"><a href="https://www.jugnoo.in/" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'jugnoo_link')}>Jugnoo (Socomo Technologies)</a> - Chandigarh, India</div>
                    </div> 
                    <div   className="cv-entry-details">
                        <ul>
                            <li>Ride booking App: Worked on drawing path on map and animation of markers through GeoPath - series of latitude longitude. This is to show the route on map and vehicles moving on road. Developed using Java with Google Map libraries.</li>
                            <li>Developed feature to show multiple vehicle types as available rides based on API call response. used Retrofit library, Gson and Android material design. Used testing libraries such as JUnit & Robolectric to replicate scenarios.</li>
                            <li>Driver App: Collaborated with management team to develop driver onboarding app which lets driver register on the platform and get alerts for ride requests. Driver app was built using Kotlin and various API such as Alarm manager, draw over other app, deeplinks integration, property animations.</li>
                            <li>POS (point of sale) App: Designed and developed initial versions of application for associated restaurants and grocery stores which directly integrate to the delivery system of the company. This app was built using Java and wrote unit tests using espresso.</li>
                        </ul>
                    </div>  
                </div>  
                
                <div   className="cv-entry">
                    <div   className="cv-entry-meta">
                        <div   className="cv-entry-header">
                            <h3   className="cv-entry-title">Brand Experiences Manager</h3>
                            <div   className="cv-entry-time">October 2015 - March 2016</div>
                        </div>  
                        <div   className="cv-entry-company"><a href="https://www.jio.com" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'reliance_jio_link')}>Reliance Jio Infocomm</a> - Mumbai, India</div>
                    </div> 
                    <div   className="cv-entry-details">
                        <ul>
                            <li>Developed wireframe and prototypes of multiple applications including JioMoney, JioCloud, JioCinema and MyJio. These prototypes were developed natively on Android Studio.</li>
                            <li>Worked on various prototyping and wireframing tools like Axure, Sketch, Adobe Photoshop, and Adobe XD. Used Titanium Appcelerator tool to develop cross-platform prototypes.</li>
                        </ul>
                    </div>  
                </div>  

                <div   className="cv-entry">
                    <div   className="cv-entry-meta">
                        <div   className="cv-entry-header">
                            <h3   className="cv-entry-title">Software Engineer</h3>
                            <div   className="cv-entry-time">October 2014 - October 2015</div>
                        </div>  
                        <div   className="cv-entry-company"><a href="http://www.eptl.in/pt/cc/home" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'eprocurement_link')}>eProcurement Technologies Pvt Ltd</a> - Ahmedabad, India</div>
                    </div> 
                    <div   className="cv-entry-details">
                        <ul>
                            <li>Contributed in development of company's two major products TenderTiger and AuctionTiger for Windows platforms using C# and XAML. Used Windows Runtime framework to maintain single code base for the Universal Windows Applications.</li>
                        </ul>
                    </div>  
                </div>  

                <div   className="cv-entry">
                    <div   className="cv-entry-meta">
                        <div   className="cv-entry-header">
                            <h3   className="cv-entry-title">Software Engineer</h3>
                            <div   className="cv-entry-time">February 2013 - October 2014</div>
                        </div>  
                        <div   className="cv-entry-company"><a href="https://www.simform.com/" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'simform_link')}>Simform Solutions Pvt Ltd</a> - Ahmedabad, India</div>
                    </div> 
                    <div   className="cv-entry-details">
                        <ul>
                            <li>As the company being service based company, I've worked on several projects in many different domains and developed Windows Phone, Windows 8 & Universal Windows Platform (UWP) applications.</li>
                            <li>Some of the various domains I've worked on are Compression technology, Image & Video Processing technologies (including video generation using frames), PDF rendering (PDF reader app), Activity Tracking System (i.e. employee tracking systems for windows desktop users), 3D model rendering in Windows desktop platform, native game development in UWP.</li>
                            <li>Windows platforms and technologies I've used here are, UWP, Windows Phone 8 and 8.1, Windows Desktop with WPF and WCF services, Java Swing, Core Java, .NET framework, C#.net, XAML and Windows Azure.</li>
                        </ul>
                    </div>  
                </div>  

        {/* Add more experience items here as needed */}
      </Reveal>

      <Reveal as="section" className="cv-section cv-projects-section" delay={220}>
        <h2 className="cv-heading">
          <span className="cv-heading-icon">
            <i className="fas fa-archive cv-heading-icon-glyph"></i>
          </span>
          <span className="cv-heading-text">Projects</span>
        </h2>
        <div className="cv-projects-intro">
          <p>Here are some of the Projects I did apart from my full-time work.</p>
        </div>
        <div className="cv-entry">
          <span className="cv-project-title">
            <a href="https://apps.microsoft.com/detail/9nblggh31bwl" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'mec_india_project_link')}>MEC India</a>
          </span>
          <ul>
            <li>Cross-Platform application for Android, iPhone & Windows using Xamarin</li>
            <li>Massively Empowered Classroom was an initiative by Microsoft Research, to bring education courses online.</li>
          </ul>
        </div>
        <div className="cv-entry">
          <span className="cv-project-title">
            <a href="https://play.google.com/store/apps/details?id=com.gensuite.onthego" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'gensuite_mobile_poroject_link')}>Gensuite Mobile</a>
          </span>
          <ul>
            <li>Native Android App - in-depth use of WebView with JavaScript</li>
            <li>EHS software solutions for a massive corporation, project through UpWork, for Gensuite LLC.</li>
          </ul>
        </div>
        <div   className="cv-entry">
                    <span   className="cv-project-title"><a href="https://www.videoshop.net/" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'videoshop_project_link')}>Videoshop</a>
                    </span> : 
                    <ul>
                        <li>Native UWP application using C++ lib for Video editing</li>
                        <li>Video generation and editing API in C++ and C# using Frames on windows platform.</li>
                    </ul>
                </div>  

                <div   className="cv-entry">
                    <span   className="cv-project-title"><a href="https://apps.microsoft.com/detail/9wzdncrfjb33" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', '8zip_project_link')}>8 Zip</a>
                    </span> : 
                    <ul>
                        <li>Native UWP application using compression technology.</li>
                        <li>open and extract any kind of compressed files like RAR, ZIP, 7zip, 7z, ZipX, Iso, Cab</li>
                    </ul>
                </div>  

                <div   className="cv-entry">
                    <span   className="cv-project-title"><a href="https://github.com/theKeval/PDFReader" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'pdfreader_project_link')}>PDF Reader</a>
                    </span> : 
                    <ul>
                        <li>Native UWP app to view and edit (annotate) PDF documents.</li>
                        <li>Individually developed this product to learn PDF operations and Iniking API.</li>
                    </ul>
                </div>  

                <div   className="cv-entry">
                    <span   className="cv-project-title"><a href="https://apps.microsoft.com/detail/9wzdncrdctb8" target="_blank" rel="noopener noreferrer" onClick={trackClick('cv', 'jobaka_project_link')}>Jo Baka</a>
                    </span> : 
                    <ul>
                        <li>Native Windows 8 Mobile application to create and share meme.</li>
                        <li>This application uses image generation/processing APIs</li>
                    </ul>
                </div>  
        {/* Add more project items here as needed */}
      </Reveal>

    </div>
  </div>
  </main>
);

export default CV;
